import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/blog/new',
  title: 'Cadastrar post',
  endpoint: '/app/blog',
}
